<!-- prettier-ignore -->

<button
  class="chat__button chat__button--stop"
  type="button"
  [attr.aria-label]="'Cancelar' | translate"
>
  <icon-stop />
</button>
